import { MenuItems } from "../types";

export const getLeafNodes = (items: MenuItems): MenuItems => {
  const leaves: MenuItems = [];

  const traverse = (nodes: MenuItems) => {
    for (const node of nodes) {
      const isLeaf = !node.children || node.children.length === 0;

      if (isLeaf) {
        leaves.push(node);
      } else if (node.children) {
        traverse(node.children);
      }
    }
  };

  traverse(items);
  return leaves;
};
